const state = {
  sidebarColors: [],
  bodyColors: [],
  cardColors: [],
  footerColors: [],
  headerColors: []
};

export default state;
